import React, { useContext, useEffect, useState } from "react";
import { Heading, Input } from "../../../components";
import { ResumeContext } from "../../../contexts/resumeContext";
import {deleteIcon, Plus} from '../../../components/Icons/Icons';

const newReferenceBlock = {
  name: "",
  institution: "",
  phone: "",
  email: "",
};

function ReferencesForm() {
  const { updateResumeInfo, resumeInfo } = useContext(ResumeContext);

  const [referenceDetails, setReferenceDetails] = useState(
    Object.values(
      resumeInfo?.misc?.references || { 0: { ...newReferenceBlock } }
    ) || [{}]
  );

  useEffect(() => {
    const miscSection = { ...resumeInfo.misc };
    miscSection["references"] = referenceDetails;

    updateResumeInfo.current("misc", miscSection, resumeInfo);
  }, [referenceDetails]);

  const handleChange = (e, ix) => {
    let referenceArr = [...referenceDetails];
    let referenceObj = referenceArr[ix];
    referenceObj[e.target.name] = e.target.value;
    referenceArr[ix] = referenceObj;
    setReferenceDetails(referenceArr);
  };
  const addNewBlock = () => {
    let referenceDetailsTemp = [...referenceDetails];
    referenceDetailsTemp = [...referenceDetailsTemp, newReferenceBlock];
    setReferenceDetails(referenceDetailsTemp);
  };

  const deleteBlock = (ix) => {
    let referenceDetailsTemp = [...referenceDetails];
    referenceDetailsTemp.splice(ix, 1);
    setReferenceDetails(referenceDetailsTemp);
  };

  return (
    <div>
      <Heading editable content="References" section="REF"/>
      {referenceDetails.map((ref, ix) => (
        <div className="block" key={`ref_${ix}`}>
          <button className="delete-btn" onClick={() => deleteBlock(ix)}><img src={deleteIcon} /></button>
          <div className="row">
            <div className="col">
              <Input
                label="Referent's Full Name"
                name="name"
                value={ref.name}
                onChange={(e) => handleChange(e, ix)}
              />
            </div>
            <div className="col">
              <Input
                label="Institution/Company"
                name="institution"
                value={ref.institution}
                onChange={(e) => handleChange(e, ix)}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                label="Email"
                name="email"
                type="email"
                value={ref.email}
                onChange={(e) => handleChange(e, ix)}
              />
            </div>
            <div className="col">
              <Input
                label="Contact Number"
                name="phone"
                type="number"
                value={ref.phone}
                onChange={(e) => handleChange(e, ix)}
              />
            </div>
          </div>
        </div>
      ))}
      <button className="link" onClick={addNewBlock}>
        Add More Reference <Plus />
      </button>
    </div>
  );
}

export default ReferencesForm;
